import { RouterService } from '@serv/router.service';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AdminGuard implements CanActivate {

    constructor(private authService: AuthService, private router: RouterService) { }

    canActivate() {
        if (!this.authService.isLoggedIn()) {
            this.router.irLogin();
            return false;
        }
        return true;
    }
}